export enum PackageGroupPackageContentType {
  Dangerous,
  Batteries,
}
